import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, throwError, timeout } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AngularDeviceInformationService } from 'angular-device-information';
import { ConstantsApplication } from '../utils/ConstantsApplication';
import { RoleUtils } from '../utils/RoleUtils';

export const noopInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const deviceInformationService = inject(AngularDeviceInformationService);
  const router = inject(Router);

  // Función para detectar móvil/tablet
  const isMobileOrTablet = () => {
    return deviceInformationService.isMobile() || deviceInformationService.isTablet();
  };

  // Función para manejar errores
  const handleError = (error: HttpErrorResponse, req: HttpRequest<any>) => {
    let errorMessage = '';
    let status = 0;
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      status = error.status;
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.error('errorMessage', errorMessage);
    console.log('status', status);
    
    if (router && typeof router.navigate === 'function') {
      if (status === 401) {
        if (!req.url.includes(environment.pathLogin)) {
          console.log('router', router);
          router.navigate(['/login']);
          console.log('navigate to login')
        }
      }
      if (status === 426) {
        if (!req.url.includes(environment.pathLogin)) {
          console.log('router', router);
          console.log('reload page')
          window.location.reload();
        }
      }
    }
    return throwError(() => error);
  };

  // Clonar request con headers
  req = req.clone({setHeaders: { Authorization: `Bearer ${environment.token}` }});
  req = req.clone({setHeaders: { 'isMobile': isMobileOrTablet() + '' }});
  req = req.clone({setHeaders: { 'deviceType': deviceInformationService.getDeviceType() }});
  req = req.clone({setHeaders: { 'versionOrigin': ConstantsApplication.VERSION_ORIGIN }});

  // Agregar branchOfficeIdCurrentParam como query param solo para admin/super user (excepto login)
  // Solo lo agrega si no está presente en la URL ni en los params
  if (RoleUtils.isAdminOrSuperUser() && environment.branchOfficeIdCurrentParam > 0) {
    const loginPath = 'api/companyx/v1/auth/login';
    if (!req.url.includes(loginPath)) {
      const url = new URL(req.url, window.location.origin);
      // Verificar si el parámetro ya existe en la URL o en los HttpParams
      if (!url.searchParams.has('branchOfficeIdCurrentParam') && !req.params.has('branchOfficeIdCurrentParam')) {
        url.searchParams.set('branchOfficeIdCurrentParam', environment.branchOfficeIdCurrentParam.toString());
        req = req.clone({ url: url.toString() });
      }
    }
  }

  if (environment.APIGW_ENABLE === true) {
    console.log('environment.APIGW_HOST', environment.APIGW_HOST);
    const url = new URL(req.url, window.location.origin);
    const newUrl = req.url.replace(url.hostname, environment.APIGW_HOST);
    req = req.clone({ url: newUrl });
  }

  console.log('interceptor url', req.url, req.url.includes(`${environment.pathCash}/open`));
  if (!environment.cashIsOpen && !req.url.includes(environment.pathCash) && !RoleUtils.isAdminOrSuperUser()) {
    console.log(req.url);
    const message = 'Primero debe aperturar su caja';
    const errorDetail = {
      error: message,
      message: message,
      status: 412,
      statusText: message
    };
    const error = { error: errorDetail };
    return throwError(() => error);
  }
  
  console.log('Método HTTP:', req.method);
  return next(req).pipe(
    timeout('GET' === req.method ? environment.timeOutGet : environment.timeOut),
    catchError((error) => {
      console.log('catchError', error);
      if (error instanceof HttpErrorResponse && error.status === 0) {
        const message = 'No hay conexión a la red';
        const customHttpErrorResponse = new HttpErrorResponse({
          error: message,
          status: 0,
          statusText: message,
          url: error.url!
        });
        return handleError(customHttpErrorResponse, req);
      } else if (error.name !== undefined && error.name === 'TimeoutError') {
        error.message = 'El servicio excedió el tiempo máximo de espera';
        if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH' || req.method === 'DELETE') {
          error.message = 'El servicio excedió el tiempo máximo de espera, verifique la transacción';
        } 
        return handleError(error, req);
      }
      return handleError(error, req);
    })
  );
};